<template>
  <NativeAdCardLarge
    v-if="showAdUnit"
    :width="getOptionValue(LayoutWidth)"
    :height="getOptionValue(LayoutHeight)"
    :entity="adEntity"
  />
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import NativeAdCardLarge from "@/smart-feed/components/native-ad/layouts/NativeAdCardLarge.vue";
import { mapActions, mapState } from "pinia";
import { usePublicationAdsStore } from "%/dynamic-component-editor/stores/publication-ads-store";
import { useFanPublicationStore } from "%/dynamic-component-editor/stores/fan-publication-store";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";

export default {
  name: "AdUnit",
  components: { NativeAdCardLarge },
  mixins: [DynamicElementMixin],
  data() {
    return {
      BaseOption,
      LayoutHeight,
      LayoutWidth,
    };
  },
  optionBundles: [
    AppearanceOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "fill",
    }, {
      "max-height": true,
      "min-height": true,
      "min-width": true,
      "max-width": true,
    }),
  ],
  elementPanelSettings: {
    tags: ["ad", "advert", "advertisement", "banner"],
    displayName: "Ad Unit",
    displayIcon: "money-bill",
    elementGroup: "general",
    elementType: "element",
  },
  computed: {
    ...mapState(usePublicationAdsStore, ["randomAd"]),
    ...mapState(useFanPublicationStore, ["publicationId", "publicationData"]),
    isAdsEnabled() {
      return this.publicationData.enable_ads === 1;
    },
    adEntity() {
      return this.randomAd;
    },
    showAdUnit() {
      if (this.editMode && this.adEntity) {
        return true;
      } else if (this.isAdsEnabled && this.adEntity) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.fetchRandomAd(this.publicationId);
  },
  methods: {
    ...mapActions(usePublicationAdsStore, ["fetchRandomAd"]),
  },
};
</script>

<style scoped lang="scss"></style>
